import { lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { useAuthStore } from '@/store/auth';
import Layout from '@/components/Layout';
import LoginPage from '@/features/auth/LoginPage';
import HomeScreen from '@/features/shift/HomeScreen';
import PointScreen from '@/features/point/PointScreen';

// Маршрут и точка — в основном бандле: с ними курьер работает весь день.
// Чат (голосовые, фото), аналитика и профиль догружаются при первом открытии.
const ChatScreen = lazy(() => import('@/features/chat/ChatScreen'));
const StatsScreen = lazy(() => import('@/features/stats/StatsScreen'));
const ProfileScreen = lazy(() => import('@/features/profile/ProfileScreen'));

export default function App() {
  const authed = useAuthStore((s) => !!s.accessToken);
  if (!authed) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/point/:pointId" element={<PointScreen />} />
        <Route path="/chat" element={<ChatScreen />} />
        <Route path="/stats" element={<StatsScreen />} />
        <Route path="/profile" element={<ProfileScreen />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
